import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requireOfficeAccess } from '@/features/auth/utils/require-office-access';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { HolidayPage } from '@/features/holidays/pages/HolidayPage';
import { holidaySearchSchema } from '@/features/holidays/types/holiday.types';

export const Route = createFileRoute('/_auth/settings/holidays')({
  beforeLoad: requireOfficeAccess,
  validateSearch: holidaySearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Holiday Calendar">
      <Suspense fallback={<PageLoader />}>
        <HolidayPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
